import axios from 'axios';
import { BASE_URL, getAxiosConfig } from '../../components/interface/Config';

const API_URL = `${BASE_URL}/resource/docs`;

export const fetchData = async (params: Record<string, any>) => {
    try {
        const response = await axios.get<{ data: { docs: any[], pagination: { total: number } } }>(
            API_URL,
            {
                params,
                headers: getAxiosConfig().headers,
            }
        );
        return response.data;
    } catch (error: any) {
        if (error.response) {
            console.error('Error Response Data:', error.response.data);
            console.error('Error Response Status:', error.response.status);
        } else {
            console.error('Error Message:', error.message);
        }
        throw new Error('Failed to fetch data.');
    }
};
